export default {
  APP_NAME: 'LetsNote',
  SIGN_IN: 'Sign In',
  SIGN_UP: 'Sign Up',
  SIGN_OUT: 'Sign out',
  NOTES: 'Notes',
  SIGN_IN_CONTINUE: 'Sign In to continue',
  GET_STARTED: 'Get Started',
  WORK_ANYWHERE: 'Work Anywhere',
  YOUR_NOTES: 'Your notes, your way',
  FIND_THINGS_FAST: 'Find things fast',
  SOMETHING_WENT_WRONG: 'Oops!! Somethings went wrong...',
  CREATE_NOTE: 'Create Note',
  UPDATE_NOTE: 'Update Note',
  TRASH: 'Trash',
  USERNAME_TAKEN: 'Username already taken!!',
  EMPTY_NOTE_CREATED: 'Empty note created!!',
  NO_EMPTY_TITLE: 'Title cannot be empty',
};
